import { MenuItem as MUIMenuItem, type MenuItemProps } from '@mui/material';
import type { ElementType } from 'react';

export { type MenuItemProps } from '@mui/material';

export function MenuItem<C extends ElementType = 'li'>(
  props: MenuItemProps<C, { component?: C }>,
) {
  return <MUIMenuItem {...(props as MenuItemProps)} />;
}
